import React, { useState, useEffect } from "react";
import Product from "../Shared/Product";
import "./HomeNewArrivals.css";
import { Link } from "react-router-dom";

const HomeNewArrivals = () => {
  const [newArrivals, setNewArrivals] = useState([]);

  useEffect(() => {
    fetch("https://ebay-backend.vercel.app/getProductsByTags?name=new arrivals")
      .then((res) => res.json())
      .then((data) => setNewArrivals(data));
  }, []);

  const products = newArrivals?.slice(1, 5);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "New Arrivals",
    itemListElement: products?.map((product, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: product?.name,
      url: `https://earthbeautyandyou.com/product/${product?.slug}`,
    })),
  };

  return (
    <section
      className="py-16 md:py-20 bg-white overflow-hidden"
      aria-label="Newly Arrived Products"
    >
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-[#729B7F] mb-3">
            Just Landed
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            New Arrivals
          </h2>
          <div className="section-divider" />
          <p className="mt-4 text-gray-500 max-w-md mx-auto text-sm md:text-base">
            Freshly formulated and ready for your routine — discover what's new.
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 featured-collections">
          {products?.length > 0
            ? products.map((product) => (
                <Product key={product?._id} product={product} />
              ))
            : Array.from({ length: 4 }).map((_, i) => (
                <div
                  key={i}
                  className="rounded-xl bg-gray-100 animate-pulse h-80"
                />
              ))}
        </div>

        {/* CTA */}
        {/* <div className="mt-12 text-center">
          <Link
            to="/newarrivals"
            className="inline-flex items-center gap-2 bg-[#729B7F] hover:bg-[#6ab558] text-white font-semibold px-8 py-2.5 rounded-xl transition-all duration-200 shadow-md hover:shadow-lg hover:-translate-y-0.5"
            title="View all new arrival products"
          >
            View All New Arrivals
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Link>
        </div> */}
      </div>
    </section>
  );
};

export default HomeNewArrivals;



// import React, { useState, useEffect } from "react";
// import Product from "../Shared/Product";
// import "./HomeNewArrivals.css";
// import { Link } from "react-router-dom";

// const HomeNewArrivals = () => {
//   const [newArrivals, setNewArrivals] = useState([]);

//   useEffect(() => {
//     fetch("https://ebay-backend.vercel.app/getProductsByTags?name=new arrivals")
//       .then((res) => res.json())
//       .then((data) => setNewArrivals(data));
//   }, []);

//   const products = newArrivals?.slice(1, 5);

//   // ✅ Structured Data for SEO
//   const structuredData = { 
//     "@context": "https://schema.org",
//     "@type": "ItemList",
//     "name": "New Arrivals",
//     "itemListElement": products?.map((product, index) => ({
//       "@type": "ListItem",
//       "position": index + 1,
//       "name": product?.name,
//       "url": `https://earthbeautyandyou.com/product/${product?.slug}`
//     }))
//   };

//   return (
//     <section
//       className="overflow-hidden"
//       aria-label="Newly Arrived Products"
//     >
//       {/* Inject JSON-LD for rich snippets */}
//       <script type="application/ld+json">{JSON.stringify(structuredData)}</script>

//       <div className="relative">
//         <div
//           className="flex flex-col px-[10px] items-center sm:px-[20px] container mx-auto"
//         >
//           {/* ✅ Changed to <h2> for better heading hierarchy */}
//           <h2 className="text-center text-xl text-accent font-bold mt-[50px] sm:text-2xl">
//             New Arrivals
//           </h2>
//           <div className="w-[100px] mx-auto h-1 bg-accent my-6 mb-10"></div>

//           <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-6 featured-collections">
//             {products?.map((product) => (
//               <Product key={product?._id} product={product} />
//             ))}
//           </div>

//           <Link
//             to="/newarrivals"
//             className="text-white bg-accent px-10 rounded sm:mt-20 py-2 hover:bg-secondary ease-in-out duration-200 font-bold sm:my-10"
//             title="View more new arrival products"
//           >
//             View More
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HomeNewArrivals;



